<li class="app-list-item" [ngClass]="{'selected':selected}">
  <div mat-ripple class="app-list-item-content" (click)="handleClick()">
    <ng-content></ng-content>
  </div>
  <div class="app-list-item-details-container" *ngIf="expanded" >
    <ng-content select="app-list-item-detail"></ng-content>
  </div>
</li>
